import {action, computed, makeObservable, observable} from "mobx";

class PrivateTalkStore {
    invitedUser = 0;
    openUserMenu = false;
    inviteToAgoraChannel = false;
    privateTalkCreated = false;
    channelName = null;
    participantPopup = false;
    agoraToken = null;
    senderUserId = null;

    constructor() {
        makeObservable(this, {
            invitedUser: observable,
            openUserMenu: observable,
            inviteToAgoraChannel: observable,
            privateTalkCreated: observable,
            channelName: observable,
            participantPopup: observable,
            agoraToken: observable,
            setInvitedUser: action.bound,
            setOpenUserMenu: action.bound,
            setInviteToAgoraChannel: action.bound,
            setPrivateTalkCreated: action.bound,
            setChannelName: action.bound,
            setParticipantPopup: action.bound,
            setAgoraToken: action.bound,
            clearPrivateTalkData: action.bound,
            setSenderUser: action.bound,
            hasPrivateCall: computed
        });
    }

    setInvitedUser(num) {
        this.invitedUser = num;
    }

    setOpenUserMenu(bool) {
        this.openUserMenu = bool;
    }

    setInviteToAgoraChannel(bool) {
        this.inviteToAgoraChannel = bool;
    }

    setPrivateTalkCreated(bool) {
        this.privateTalkCreated = bool;
    }

    setChannelName(str) {
        this.channelName = str;
    }

    setParticipantPopup(bool) {
        this.participantPopup = bool;
    }

    setAgoraToken(str) {
        this.agoraToken = str;
    }

    get hasPrivateCall() {
        return !!this.channelName
    }

    setSenderUser(id){
        this.senderUserId = id
    }

    clearPrivateTalkData() {
        this.invitedUser = 0;
        this.openUserMenu = false;
        this.inviteToAgoraChannel = false;
        this.privateTalkCreated = false;
        this.channelName = null;
        this.participantPopup = false;
        this.agoraToken = null;
        this.senderUserId = null;
    }
}

export const privateTalkStore = new PrivateTalkStore();
